'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('committeeModule')

.factory('committeeService', ['$http', function ($http) {
    var baseUrl = environment.apiUrl + '/Pilot/api/Committee';

    var service = {};

    // Committee
    service.getCommittee = function (committeeId) {
        return $http
            .get(baseUrl + '/' + committeeId)
            .then(function (response) { return response.data; });
    };

    service.deleteCommittee = function (committeeId) {
        return $http
            .delete(baseUrl + '/' + committeeId)
            .then(function (response) { return response.data; });
    };

    service.createCommittee = function (committee) {
        var reqUrl = baseUrl;

        return $http
            .post(reqUrl, { Committee: committee })
            .then(function (response) { return response.data; });
    };

    service.updateCommittee = function (committee) {
        var reqUrl = baseUrl + '/' + committee.CommitteeID;

        return $http
            .put(reqUrl, { Committee: committee })
            .then(function (response) { return response.data; });
    };

    // Lookups
    service.getAllLookups = function () {
        return $http
            .get(baseUrl + '/Lookup', { cache: true, ignoreError: true })
            .then(function (response) { return response.data; });
    };

    return service;
}]);
